<template>
    <div class="lease">
        <!--<top_nav class="lease_nav"></top_nav>-->
        <div class="bg_box">
            <!--<img src="../../assets/images/bg/help_bg.png" alt="">-->
            <div class="bg_con">嘉联华
                <div class="bg_dot"></div>
                律师调解
            </div>
        </div>
        <div class="subfield_box">
            <div class="subfield_left_box">

                <div class="subfield_left">
                    <div class="subfield_left_item" v-for="item in list" :key="item.id"
                         :class="{tabActive:leftTab === item.id}" @click="changeTab(item.id)">
                        {{ item.title}}
                    </div>
                </div>
            </div>
            <div class="subfield_right_box">
                <div class="subfield_right">
                    <div class="subfield_right_con" v-show="leftTab === item.id"
                         v-for="item in list" :key="item.id">
                        <!--<div v-html="item.content"></div>-->
                        <div v-if="item.content != null">
                            <div v-html="contents" v-for="(contents, indexs) in item.content.split('\n')" :key="indexs"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	// import top_nav from '../../components/nav.vue'
	import {lawyer} from "../../apiNew/index";

	export default {
		name: '',
		data() {
			return {
				leftTab: '',
				list: [],
				total: 0,
				page: 0,
				limit: 10,
			}

		},
		components: {
			// top_nav
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				lawyer({
					page: this.page,
					limit: this.limit,
				}).then(res => {
					console.log(res)
					this.list = res.data.data
					if (res.data.data.length > 0) {
						this.leftTab = this.list[0].id
					}
					this.total = res.data.total
				}).catch(error => {
					console.log(error)
								})
			},
			changeTab(n) {
				this.leftTab = n
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import "lawyer";
</style>